module.exports = __webpack_public_path__ + "static/profil-127_optimized-69b34ff6ed40dd8eb5080bc751b2607e.jpg";